import React from 'react'
import { Item, Button, Header, Image, Modal, Label } from 'semantic-ui-react'

const colors = [
  'blue', 'violet', 'purple', 'pink', 'red', 'orange', 'yellow', 'olive', 'green', 'teal',
]

const MyWorksList = (props)=>(
    props.tab_works_content.map((v,k)=>(
      <Item key={k}>
        <Item.Image size='tiny' src={v.img_fil+v.img}/>
        <Item.Content>
          <Item.Header>
            {v.title}
          </Item.Header>
          {v.website&&<Item.Meta>
            【<a className="site_link" target="_blank" href={v.website}>Website</a>】
                    </Item.Meta>}
          <Item.Description>
              {v.intro}

          </Item.Description>
          <Item.Extra>
              <Modal trigger={<Button basic color='teal' size='mini'>Show</Button>} closeIcon>
                <Modal.Header>{v.title}</Modal.Header>
                <Modal.Content image>
                  <Image wrapped size='medium' src={v.img_fil+v.img} />
                  <Modal.Description>
                    <Header>{v.title}</Header>
                    <div className="work_details">{v.detail_intro}</div>
                    <div className="work_details tags">
                      {v.service.map((service,k) => (
                        <Label color={colors[k]} key={service} service={service}>
                          {service}
                        </Label>
                      ))}
                    </div>
                    {v.website&&
                    <div>
                      <br/>
                      Website： <a className="site_link" target="_blank" href={v.website}>{v.website}</a>
                    </div>
                    }
                  </Modal.Description>
                </Modal.Content>
              </Modal>

          </Item.Extra>
        </Item.Content>
      </Item>
    ))
)

const TabWorksContent = (props) => (
  <div className="tab-works-content">
    <Item.Group>
        <MyWorksList {...props}/>
    </Item.Group>
  </div>
)

export default TabWorksContent


// WEBPACK FOOTER //
// ./src/components/TabWorksContent.js